import {autoinject, newInstance, LogManager, PLATFORM} from "aurelia-framework";
import {HttpClient} from "aurelia-http-client";
import {preserveRequest,responseContent,handleResponse} from "../tools/http/http";
import {Redirecter} from "../marketing-pages/utility/redirecter";

const logger = LogManager.getLogger("AuthService");
logger.setLevel(LogManager.logLevel.debug);

@autoinject()
export class AuthService {

  constructor(@newInstance() private __httpClient: HttpClient) {
    this.__httpClient = __httpClient.configure(x => {
      x.withBaseUrl("/dssb/fe/");
      x.withHeader('Content-Type', 'application/json');
      x.withHeader('pragma', 'no-cache');
      x.withHeader('cache-control', 'no-cache');
    });
  }

  signIn(login,password, mfaHash?, mfaCode?) {
    logger.debug("signing in...");
    // @ts-ignore
    return handleResponse(this.__httpClient.post("login", {login:login , password:password, mfaHash: mfaHash, mfaCode: mfaCode}, {withCredentials:true,credentials: 'same-origin'}));
  }

  register(credentials) {
    logger.debug("signing in...");
    return handleResponse(this.__httpClient.post("add-user", credentials));
  }

  resendVerification(userData) {
    logger.debug('Re-send verification code');
    return responseContent(this.__httpClient.post('resendMfaKey', userData));
  }

  checkSession(){
    logger.debug("checking session...");

    return this.__httpClient.get("check-session");
  }

  checkUserLooged(){
    logger.debug("checking if user logged...");
    return this.__httpClient.get("user-logged");
  }

  getParameters(){
    logger.debug("getting parameters...");

    return this.__httpClient.get("get-initial-params");
  }

  forgotPwd(email){

    let data =  JSON.stringify(
      {
        appId: 'web',
        email: email
      });
    return handleResponse(this.__httpClient.post("../forgotpwd",data));
  }

  resetPwd(resetPassword, code){
    return handleResponse(this.__httpClient.post(`../resetpwd/${code}`,resetPassword));
  }

  logOut() {
    logger.debug("Logout... sessionId=" + PLATFORM.global.LoginInfo.sessionId
        + ", deviceId=" + PLATFORM.global.setDeviceId());

    const $this = this;

    const canUnload = WBusRegistrator.canUnloadWidgets();
    if(!canUnload) {
      confirm(
        "Warning!", 
        "You have unsaved data. Do you want log out anyway?",
        function () {
          WBusRegistrator.blockBeforeUnload();
          WBusRegistrator.canLogout().then(() => {
              $this.logoutInner();
          });
        },
        function () {
        }
      );
    } else {
      WBusRegistrator.canLogout().then(() => {
        this.logoutInner();
      });
    } 
  }

  logoutInner() {
    //Switchboard logout
    if(PLATFORM.global.logout){
      PLATFORM.global.logout();
    }
    return preserveRequest(this.__httpClient.post("logout", {
      deviceId: PLATFORM.global.setDeviceId(),
      sessionId: PLATFORM.global.LoginInfo.sessionId
    }), promise => promise.then(
      () => Redirecter.goToNewMarketingPages(),
      e => logger.error(e)
    ));
  }

  changeLanguage(languageCode) {
    return preserveRequest(
      this.__httpClient.get(`../changeLang/${languageCode}`),
      promise => promise.then(
        () => PLATFORM.global.location.reload(true),
        e => logger.error(e)
      )
    );
  }

  checkPassword(email, password) {
    return responseContent(this.__httpClient.post('check-password', {email, password}));
  }

}

export class AuthUser {

  isLogged: boolean = false;

  constructor(attrs?: {isLogged?: boolean}) {
    if (attrs) {
       if(attrs.isLogged){
         this.isLogged = true;
       }
    }
  }

  get logedIn() {
    return this.isLogged;
  }
}


